import { render, staticRenderFns } from "./UnfinishedTask.vue?vue&type=template&id=0587d36b&scoped=true"
import script from "./UnfinishedTask.vue?vue&type=script&lang=ts"
export * from "./UnfinishedTask.vue?vue&type=script&lang=ts"
import style0 from "./UnfinishedTask.vue?vue&type=style&index=0&id=0587d36b&prod&lang=css"
import style1 from "./UnfinishedTask.vue?vue&type=style&index=1&id=0587d36b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587d36b",
  null
  
)

export default component.exports